import { render, staticRenderFns } from "./AirRemoteDialog.vue?vue&type=template&id=23b23990"
import script from "./AirRemoteDialog.vue?vue&type=script&lang=js"
export * from "./AirRemoteDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports